<div class="ct-color-picker">
    <p-colorPicker [ngModel]="bgColor"
                   (onChange)="writeValue($event.value)" #colorPicker></p-colorPicker>
    <input class="ct-input"
           [name]="name"
           [disabled]="disabled"
           [(ngModel)]="modelValue"
           mask = "numberMask"
           dropSpecialCharacters = "false"
           (ngModelChange)="writeValue(modelValue)">
</div>
